export const SpaceStateFilterValues = {
  AVAILABLE:
    'spaceUnavailabilityStatePeriods IS EMPTY OR spaceUnavailabilityStatePeriods.from > NOW() OR spaceUnavailabilityStatePeriods.until < NOW()',
  BLOCKED:
    'spaceUnavailabilityStatePeriods.state = "BLOCKED" AND spaceUnavailabilityStatePeriods.from <= NOW() AND spaceUnavailabilityStatePeriods.until >= NOW()',
  BOOKED:
    'spaceUnavailabilityStatePeriods.state = "BOOKED" AND spaceUnavailabilityStatePeriods.from <= NOW() AND spaceUnavailabilityStatePeriods.until >= NOW()',
} as const;
